
const getHtmlClassByHint = (selector, hint) => {
  const classString = selector.getAttribute('class');
  const classArray = classString.split(' ');

  if(typeof hint !== 'string') {
    return;
  }

  const findHint = (text) => {
    return text.includes(hint);
  }

  return classArray.find(findHint);
}

export default getHtmlClassByHint;
